"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var shortid_1 = __importDefault(require("shortid"));
var components_1 = require("../../components");
var Button_1 = require("../Button");
var FormProvider_1 = __importDefault(require("../FormProvider"));
require("./AppLayout.scss");
var ComplianceLayout = function (_a) {
    var confirmLabel = _a.confirmLabel, checkboxLabel = _a.checkboxLabel, children = _a.children, dusk = _a.dusk, title = _a.title, onConfirm = _a.onConfirm;
    var checkboxId = react_1.useMemo(function () { return shortid_1.default(); }, []);
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: "app-layout app-layout--sm" },
        react_1.default.createElement("div", { className: "app-layout--container max-w-2xl mx-auto" },
            react_1.default.createElement(components_1.PageHeader, { dusk: "page-header", title: title, breadcrumbs: [] }),
            react_1.default.createElement(FormProvider_1.default, { initialValues: { agree: false }, onSubmit: onConfirm }, function (form) { return (react_1.default.createElement(components_1.Form, null,
                react_1.default.createElement(components_1.Card, { footer: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(components_1.Button, { type: Button_1.ButtonType.submit, processing: form.isSubmitting, disabled: form.isSubmitting || form.values.agree
                                ? false
                                : true }, confirmLabel),
                        react_1.default.createElement("div", { className: "flex items-center flex-grow" },
                            react_1.default.createElement(components_1.FormLabel, { htmlFor: checkboxId, label: checkboxLabel }),
                            react_1.default.createElement(components_1.Checkbox, { id: checkboxId, name: "agree" }))) }, children))); }))));
};
exports.default = ComplianceLayout;
//# sourceMappingURL=ComplianceLayout.js.map